import { Currency, Language } from '@/domainLogic/index.ts';

export const getMaxPrice = (lang: Language, currency: Currency): number => {
  const basePrice = 3000;

  if (lang === Language.CS) return basePrice * 25;
  if (lang === Language.RO || lang === Language.PL) return basePrice * 5;
  if (lang === Language.HU) return basePrice * 400;
  if (lang === Language.DA) return basePrice * 7;
  if (lang === Language.SV || lang === Language.NO) return basePrice * 10;
  if (currency === Currency.ARS) return basePrice * 1380;
  if (currency === Currency.CLP) return basePrice * 1120;
  if (currency === Currency.INR) return basePrice * 100;
  if (currency === Currency.ISK) return basePrice * 142;
  if (currency === Currency.MXN) return basePrice * 21;

  return basePrice;
};
